import { render, staticRenderFns } from "./properties-block-button.vue?vue&type=template&id=59d49e5e&scoped=true"
import script from "./properties-block-button.vue?vue&type=script&lang=js"
export * from "./properties-block-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d49e5e",
  null
  
)

export default component.exports